import { render, staticRenderFns } from "./masterClientApp.vue?vue&type=template&id=352145c9&"
import script from "./masterClientApp.vue?vue&type=script&lang=js&"
export * from "./masterClientApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports